export const defaultLng = 'uk'
